// Reações (chips de emoji embaixo da bolha) e a barra de ações que aparece ao passar o
// mouse ou focar a bolha na thread ao vivo: 6 reações rápidas, remover e Responder.
// O WhatsApp aceita UMA reação por lado; a da loja substitui a anterior.
import { XIcon } from '@/components/icons';
import type { MessageReaction } from '../api';
import styles from './MessageBubbleParts.module.css';

export const QUICK_REACTIONS = ['👍', '❤️', '😂', '😮', '😢', '🙏'] as const;

const ACTOR_LABEL: Record<MessageReaction['actor'], string> = {
  CUSTOMER: 'do cliente',
  STORE: 'da loja',
};

/** Chips agrupados por emoji (cliente e loja com o mesmo emoji viram "❤️ 2"). */
export function ReactionChips({ reactions }: { reactions: MessageReaction[] }) {
  if (reactions.length === 0) return null;
  const groups = new Map<string, MessageReaction[]>();
  for (const r of reactions) {
    if (!r.emoji) continue;
    groups.set(r.emoji, [...(groups.get(r.emoji) ?? []), r]);
  }
  if (groups.size === 0) return null;
  return (
    <ul className={styles.reactions} aria-label="Reações">
      {[...groups.entries()].map(([emoji, list]) => (
        <li
          key={emoji}
          className={styles.reactionChip}
          aria-label={`${emoji} ${list.map((r) => ACTOR_LABEL[r.actor]).join(' e ')}`}
        >
          <span aria-hidden="true">{emoji}</span>
          {list.length > 1 && (
            <span className={styles.reactionCount} aria-hidden="true">
              {list.length}
            </span>
          )}
        </li>
      ))}
    </ul>
  );
}

interface ToolbarProps {
  /** Emoji atual da loja nesta mensagem ('' = nenhum). */
  storeEmoji: string;
  onReact: (emoji: string) => void;
  onReply: () => void;
}

export function BubbleToolbar({ storeEmoji, onReact, onReply }: ToolbarProps) {
  return (
    <div className={styles.toolbar} role="toolbar" aria-label="Ações da mensagem">
      {QUICK_REACTIONS.map((emoji) => (
        <button
          key={emoji}
          type="button"
          className={styles.toolbarEmoji}
          aria-label={`Reagir com ${emoji}`}
          aria-pressed={storeEmoji === emoji}
          // Clicar de novo no emoji que já está lá remove, como no WhatsApp.
          onClick={() => onReact(storeEmoji === emoji ? '' : emoji)}
        >
          {emoji}
        </button>
      ))}
      {storeEmoji && (
        <button
          type="button"
          className={styles.toolbarButton}
          aria-label="Remover reação"
          title="Remover reação"
          onClick={() => onReact('')}
        >
          <XIcon size={14} />
        </button>
      )}
      <button type="button" className={styles.toolbarReply} onClick={onReply}>
        Responder
      </button>
    </div>
  );
}
